import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { get, post, put, uploadSiteCheckDoc } from "../../../../api";
import {
  Grid, TextField, Checkbox, Typography, Box, IconButton, FormGroup, Select, InputLabel, FormControl, FormControlLabel,
  Accordion, Chip, AccordionSummary, AccordionDetails, Card, CardContent, Autocomplete
} from '@mui/material';
import { UploadFile, Close, ExpandMore } from '@mui/icons-material';
import { deleteUser, getSites, getUsers, getSiteCheckAssets, getSiteLayout } from "../../../../store/thunk/site";

const AssessmentFireRisk = ({ sasToken, checkId,subType, siteAssets, getSiteCheckAssets, siteSelectedForGlobal, getSiteLayout, siteLayout }) => {
  const [risks, setrisks] = useState([0, 0, 0, 0])
  const [quest, setquest] = useState([]);
  const [openIndex, setOpenIndex] = useState(0);

  useEffect(() => {
    getQuestions();
    if (siteSelectedForGlobal?.siteId) {
      getSiteCheckAssets(siteSelectedForGlobal?.siteId);
      getSiteLayout(siteSelectedForGlobal?.siteId)
    }
  }, []);

  const applyQuestionResponse = (idx, nextResponse) => {
    const uquest = [...quest];
    uquest[idx].response = nextResponse;
    setquest(uquest);
  };

  const clearNoDetails = (existing = {}) => ({
    ...existing,
    riskType: "",
    floor: "",
    room: "",
    position: "",
    assets: "",
    action: "",
    file: null,
    consequence: "",
    likelihood: "",
  });

  const getTypeNodeForRiskType = (riskType) => {
    const normalized = String(riskType || "").trim().toLowerCase();
    const targetName =
      normalized === "external" ? "exterior" :
      normalized === "internal" ? "interior" :
      normalized;

    return (siteLayout || []).find((n) => {
      if (String(n?.nodeType || "").toLowerCase() !== "type") return false;
      const name = String(n?.nodeName || "").trim().toLowerCase();
      return name === targetName;
    });
  };

  const getFloorsForRiskType = (riskType) => {
    const typeNode = getTypeNodeForRiskType(riskType);
    if (!typeNode) return [];
    return (siteLayout || []).filter(
      (n) => String(n?.nodeType || "").toLowerCase() === "floor" && String(n?.parentNode) === String(typeNode?.id)
    );
  };

  const getRoomsForFloorId = (floorId) => {
    if (!floorId) return [];
    return (siteLayout || []).filter(
      (n) => String(n?.nodeType || "").toLowerCase() === "room" && String(n?.parentNode) === String(floorId)
    );
  };

  // const defaultQuestions = [
  //   {
  //     q: "Are all means of escape free from combustible and other storage?",
  //     s: "Open"
  //   },
  //   {
  //     q: "Are sufficiently robust and applicable systems in place for the safe storage and use of flammable substances?",
  //     s: "Closed"
  //   },
  //   {
  //     q: "Are all means of escape free from combustible and other storage?",
  //     s: "Open"
  //   },
  //   {
  //     q: "All means provided to ensure adequate Means Of Escape (other than floors walls and ceilings, see above) must be properly maintained",
  //     s: "Open"
  //   },
  //   {
  //     q: "Is the building provided with signs and notices in accordance with the Signs and Signals Regulations 1996?",
  //     s: "Open"
  //   },
  //   {
  //     q: "Were there is a need for a degree of fire resistance, are doors provided constructed in accordance with relevant part of B.S. 476?",
  //     s: "Open"
  //   },
  //   {
  //     q: "Is emergency lighting provided and maintained in accordance with B.S.5266: 2003?",
  //     s: "Open"
  //   },
  //   {
  //     q: "Is the building provided with fire fighting equipment in compliance with B.S 5306, Part 3?",
  //     s: "Open"
  //   },
  //   {
  //     q: "Are all means of escape free from combustible and other storage?",
  //     s: "Open"
  //   },
  // ]

  // const temp = async () => {
  //   for (let d of defaultQuestions) {
  //     const data = {
  //       question: d.q,
  //       category: "assessment-fire-risk"
  //     }
  //     await post("/api/site-check/assessment/questions", data)
  //   }


  // }

  const getQuestions = async () => {
    const questionsFromDB = await get("/api/site-check/assessment/questions/"+subType)
    const questionsResponse = await get("/api/site-check/assessment/response/" + checkId)
    questionsFromDB.forEach(q => {
      const resIdx = questionsResponse.findIndex(r => r.qid === q.qid);
      if (resIdx >= 0) {
        q.status = "Closed";
        q.response = questionsResponse[resIdx]
        q.completed = true
      } else {
        q.status = "Open";
        q.response = {}
        q.completed = false
      }
    })
    const risksN = [0, 0, 0, 0]
    questionsResponse.forEach(r => {
      if (r.totalRiskScore > 17) {
        risksN[0] = risksN[0] + 1;
      } else if (r.totalRiskScore > 10) {
        risksN[1] = risksN[1] + 1;
      } else if (r.totalRiskScore > 5) {
        risksN[2] = risksN[2] + 1;
      } else {
        risksN[3] = risksN[3] + 1;
      }

    })
    setrisks(risksN)
    const body = {
      riskScoreRed: risksN[0],
      riskScoreAmber: risksN[1],
      riskScoreYellow: risksN[2],
      riskScoreGreen: risksN[3],
    }
    await put("/api/site-check/" + checkId, body);
    setquest(questionsFromDB);
  }




  const handleInputChange = (e, idx) => {
    const { name, value } = e.target;
    const uquest = [...quest]
    const udata = {
      ...quest[idx].response,
      [name]: value,
    }
    uquest[idx].response = udata
    setquest(uquest);
  };

  const setResponseCheck = (e, idx) => {
    if (quest[idx]?.completed) return;
    e.stopPropagation();
    setOpenIndex(idx);
    const checked = e.target.checked;
    const current = quest[idx]?.response?.response;

    if (checked) {
      applyQuestionResponse(idx, {
        ...clearNoDetails({ ...(quest[idx].response || {}) }),
        response: "Yes",
      });
      return;
    }
    if (current === "Yes") {
      applyQuestionResponse(idx, clearNoDetails({ ...(quest[idx].response || {}), response: "" }));
    }
  };

  const setResponseCheck2 = (e, idx) => {
    if (quest[idx]?.completed) return;
    e.stopPropagation();
    setOpenIndex(idx);
    const checked = e.target.checked;
    const current = quest[idx]?.response?.response;

    if (checked) {
      const existing = quest[idx].response || {};
      applyQuestionResponse(idx, {
        ...existing,
        response: "No",
        riskType: existing.riskType || "",
        floor: existing.floor || "",
        room: existing.room || "",
        position: existing.position || "",
        assets: existing.assets || "",
        action: existing.action || "",
        file: existing.file || null,
        consequence: existing.consequence || "",
        likelihood: existing.likelihood || "",
      });
      setTimeout(() => {
        const el = document.getElementById(`assessment-q-${idx}`);
        if (el && typeof el.scrollIntoView === "function") {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 0);
      return;
    }
    if (current === "No") {
      applyQuestionResponse(idx, clearNoDetails({ ...(quest[idx].response || {}), response: "" }));
    }
  };

  const handleFileChange = (e, idx) => {
    const uquest = [...quest]
    uquest[idx].response.file = e.target.files[0]
    setquest(uquest);
  };

  const handleFileDelete = (idx) => {
    const uquest = [...quest]
    uquest[idx].response.file = null
    setquest(uquest);
  };

  const validateNoResponse = (data) => {
    const missing = [];
    if (!String(data?.riskType || "").trim()) missing.push("Internal/External");
    if (!String(data?.floor || "").trim()) missing.push("Floor");
    if (!String(data?.room || "").trim()) missing.push("Room");
    if (!String(data?.position || "").trim()) missing.push("Observation");
    if (!String(data?.consequence || "").trim()) missing.push("Consequence");
    if (!String(data?.likelihood || "").trim()) missing.push("Likelihood");
    return missing;
  };

  const saveAssessmentResponse = async (event, index) => {
    event.preventDefault();
    const dataToSave = { ...quest[index].response };

    if (dataToSave?.response === "No") {
      const missing = validateNoResponse(dataToSave);
      if (missing.length > 0) {
        toast.error(`Please complete: ${missing.join(", ")}. Asset and Suggested Action are optional.`);
        setOpenIndex(index);
        setTimeout(() => {
          const el = document.getElementById(`assessment-q-${index}`);
          if (el && typeof el.scrollIntoView === "function") {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 0);
        return;
      }
    }

    if (dataToSave.assets === undefined || dataToSave.assets === null) {
      dataToSave.assets = "";
    }
    if (dataToSave.action === undefined || dataToSave.action === null) {
      dataToSave.action = "";
    }
    if (dataToSave?.file?.name) {
      dataToSave.siteId = siteSelectedForGlobal?.siteId;
      dataToSave.file = await uploadSiteCheckDoc(dataToSave);
    }
    dataToSave.responseDate = new Date();
    dataToSave.checkId = checkId;
    dataToSave.qid = quest[index].qid;
    dataToSave.status = "Closed";
    dataToSave.totalRiskScore = Number(dataToSave.consequence ?? 0) * Number(dataToSave.likelihood ?? 0)
    await post("/api/site-check/assessment/response", dataToSave);
    await getQuestions();
    toast.success("Assessment response saved")
  }


  return (

    <Box p={3}>
      <Card>
        <CardContent>
          <Grid container alignItems="center" justifyContent="space-between" mb={2}>
            <Grid item>
              <Typography variant="h6">Questions</Typography>
            </Grid>
            <Grid item>
              <Box display="flex" alignItems="center">
                <Typography variant="body1" style={{ backgroundColor: '#E0E7FF', padding: '4px 8px', borderRadius: '4px' }}>
                  Total: {quest.length}, Open: {quest.filter(q => q.status === "Open").length}, Closed: {quest.filter(q => q.status === "Closed").length}
                </Typography>
                <Box ml={2} display="flex" alignItems="center">
                  <Box width={24} height={24} bgcolor="#F44336" display="flex" alignItems="center" justifyContent="center" borderRadius="4px" mx={0.5}>
                    {/* <Typography variant="body2" color="white">{risks[0]}</Typography> */}
                    <span className="badge bg-danger p-2 m-1 risk-span">
                      {risks[0]}
                    </span>
                   
                   
                  
                  </Box>
                  <Box width={24} height={24} bgcolor="#FF9800" display="flex" alignItems="center" justifyContent="center" borderRadius="4px" mx={0.5}>
                    {/* <Typography variant="body2" color="white">{risks[1]}</Typography> */}
                    <span className="badge bg-warning p-2 m-1 risk-span">
                      {risks[1]}
                    </span>
                  </Box>
                  <Box width={24} height={24} bgcolor="#FFEB3B" display="flex" alignItems="center" justifyContent="center" borderRadius="4px" mx={0.5}>
                    {/* <Typography variant="body2" color="white">{risks[2]}</Typography> */}
                    <span className="badge bg-info p-2 m-1 risk-span">
                      {risks[2]}
                    </span>
                  </Box>
                  <Box width={24} height={24} bgcolor="#4CAF50" display="flex" alignItems="center" justifyContent="center" borderRadius="4px" mx={0.5}>
                    {/* <Typography variant="body2" color="white">{risks[3]}</Typography> */}
                    <span className="badge bg-success p-2 m-1 risk-span">
                      {risks[3]}
                    </span>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>

          {quest?.map((q, idx) =>
            <Accordion
              id={`assessment-q-${idx}`}
              expanded={idx === openIndex}
              onChange={(event, expanded) => setOpenIndex(expanded ? idx : -1)}
            >
              <AccordionSummary expandIcon={<ExpandMore />} >
                <Typography>Q{idx + 1}. {q.question}
                  <Checkbox
                    disabled={quest[idx]?.completed}
                    checked={quest[idx]?.response?.response === "Yes"}
                    onClick={(e) => e.stopPropagation()}
                    onFocus={(e) => e.stopPropagation()}
                    onChange={(e) => setResponseCheck(e, idx)}
                  />{" "}
                  Yes
                  <Checkbox
                    disabled={quest[idx]?.completed}
                    checked={quest[idx]?.response?.response === "No"}
                    onClick={(e) => e.stopPropagation()}
                    onFocus={(e) => e.stopPropagation()}
                    onChange={(e) => setResponseCheck2(e, idx)}
                  />{" "}
                  No
                </Typography> 
                &nbsp;&nbsp;&nbsp;&nbsp;<Chip style={{ margin: '5px', marginLeft: '30px'}} color={q.status === "Closed" ? "success" : "primary"} label={q.status} />
              </AccordionSummary>
              {quest[idx]?.response?.response === "No" && <AccordionDetails>
                <form
                  noValidate
                  onSubmit={(e) => {
                    setOpenIndex(idx + 1);
                    saveAssessmentResponse(e, idx);
                  }}
                >
                  <Grid container spacing={2}>
                    {/* <Grid item xs={6}>
                      <label htmlFor="response" name="response">
                        Response
                      </label>
                      <select
                        disabled={quest[idx]?.completed}
                        className="form-control form-select"
                        name="response"
                        required
                        value={quest[idx]?.response?.response}
                        onChange={(e) => handleInputChange(e, idx)}
                      >
                        <option value="">Select </option>
                        {["Yes", "No"].map((num) => (
                          <option value={num}>{num} </option>
                        ))}
                      </select>

                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="riskType" name="riskType">
                        Internal/External
                      </label>
                      <select
                        disabled={quest[idx]?.completed}
                        className="form-control form-select"
                        name="riskType"
                        onChange={(e) => {
                          const nextRiskType = e.target.value;
                          const existing = quest[idx].response || {};
                          applyQuestionResponse(idx, {
                            ...existing,
                            riskType: nextRiskType,
                            floor: "",
                            room: "",
                          });
                        }}
                        value={quest[idx]?.response?.riskType || ""}
                      >
                        <option value="">Select </option>
                        {["Internal", "External"].map((num) => (
                          <option value={num}>{num} </option>
                        ))}
                      </select>

                    </Grid>
                    <Grid item xs={12} sm={6}>

                      <label htmlFor="floor" name="floor">
                        Floor
                      </label>
                      <select
                        disabled={quest[idx]?.completed || !quest[idx]?.response?.riskType}
                        className="form-control form-select"
                        name="floor"
                        value={quest[idx]?.response?.floor || ""}
                        onChange={(e) => {
                          const nextFloor = e.target.value;
                          const existing = quest[idx].response || {};
                          applyQuestionResponse(idx, {
                            ...existing,
                            floor: nextFloor,
                            room: "",
                          });
                        }}
                      >
                        <option value="">Select </option>
                        {getFloorsForRiskType(quest[idx]?.response?.riskType).map((site) => (
                          <option value={site.id}>{site.nodeName} </option>
                        ))}
                      </select>

                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <label htmlFor="room" name="room">
                        Room
                      </label>
                      <select
                        disabled={quest[idx]?.completed || !quest[idx]?.response?.floor}
                        className="form-control form-select"
                        name="room"
                        value={quest[idx]?.response?.room || ""}
                        onChange={(e) => handleInputChange(e, idx)}
                      >
                        <option value="">Select </option>
                        {getRoomsForFloorId(quest[idx]?.response?.floor).map((site) => (
                          <option value={site.id}>{site.nodeName}</option>
                        ))}
                      </select>

                    </Grid>
                    <Grid item xs={12}>
                      <label htmlFor="position" name="position">
                        Observation
                      </label>
                      <textarea
                        disabled={quest[idx]?.completed}
                        name="position"
                        className="form-control"
                        id="position"
                        rows="4"
                        placeholder="Enter notes..."
                        value={quest[idx]?.response?.position || ""}
                        onChange={(e) => handleInputChange(e, idx)}
                        style={{ width: '100%', padding: '10px', margin: '8px 0', borderRadius: '4px', border: '1px solid #ccc' }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        disabled={quest[idx]?.completed}
                        multiple
                        onChange={(event, item) => {
                          const uquest = [...quest]
                          uquest[idx].response = {
                            ...uquest[idx].response,
                            assets: item?.length ? item.map((i) => i.key).join(",") : "",
                          }
                          setquest(uquest);
                        }}
                        value={siteAssets.filter(s => quest[idx]?.response?.assets?.split(",")?.includes(s.assetId.toString())).map((option) => { return { key: option.assetId, label: option.assetName + " - " + option.category } })}

                        options={siteAssets.map((option) => { return { key: option.assetId, label: option.assetName + " - " + option.category } })}
                        getOptionLabel={(option) => option.label}

                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Search Asset (optional)"
                            required={false}
                            inputProps={{
                              ...params.inputProps,
                              required: false,
                            }}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <label htmlFor="action" name="action">
                        Suggested Action (optional)
                      </label>
                      <textarea
                        disabled={quest[idx]?.completed}
                        name="action"
                        className="form-control"
                        id="action"
                        rows="4"
                        placeholder="Optional — enter suggested action if applicable"
                        value={quest[idx]?.response?.action || ""}
                        onChange={(e) => handleInputChange(e, idx)}
                        style={{ width: '100%', padding: '10px', margin: '8px 0', borderRadius: '4px', border: '1px solid #ccc' }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      {!quest[idx]?.completed &&
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          border="1px dashed grey"
                          p={2}
                          mb={2}
                          style={{
                            backgroundColor: '#f9f9f9',
                            height: '150px',
                            borderRadius: '4px',
                            color: '#3f51b5',
                          }}
                        >
                          <IconButton component="label">
                            <input hidden type="file" onChange={(e) => handleFileChange(e, idx)} />
                            <UploadFile />
                          </IconButton>
                          <Typography>
                            Click to upload or drag and drop PNG/JPG (max, 1MB)
                          </Typography>
                        </Box>
                      }

                    </Grid>
                    {!quest[idx]?.completed && quest[idx]?.response?.file && (
                      <Grid item xs={12} container alignItems="center" >
                        <Chip
                          label={quest[idx]?.response?.file?.name}
                          onDelete={() => handleFileDelete(idx)}

                        />

                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Typography variant="h6" gutterBottom>
                        Risk Score Card (<strong>Total Risk Score = {(quest[idx]?.response?.consequence ?? 0) * (quest[idx]?.response?.likelihood ?? 0)}</strong>)
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <Grid item xs={12} sm={12}>
                            <label htmlFor="consequence" name="consequence">
                              Consequence
                            </label>
                            <select
                              disabled={quest[idx]?.completed}
                              className="form-control form-select"
                              name="consequence"
                              value={quest[idx]?.response?.consequence || ""}
                              onChange={(e) => handleInputChange(e, idx)}
                            >
                              <option value="">Select </option>
                              {[1, 2, 3, 4, 5].map((num) => (
                                <option value={num}>{num} </option>
                              ))}
                            </select>

                          </Grid>
                          <Grid item xs={12} sm={12}>

                            <label htmlFor="likelihood" name="likelihood">
                              Likelihood
                            </label>
                            <select
                              disabled={quest[idx]?.completed}
                              className="form-control form-select"
                              name="likelihood"
                              value={quest[idx]?.response?.likelihood || ""}
                              onChange={(e) => handleInputChange(e, idx)}
                            >
                              <option value="">Select </option>
                              {[1, 2, 3, 4, 5].map((num) => (
                                <option value={num}>{num} </option>
                              ))}
                            </select>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            p={2}
                            mb={2}
                            style={{
                              height: '290px',
                              marginTop: '-70px'
                            }}
                          >
                            <img
                              src="/RiskScore.png"
                              alt="Risk Score Matrix"
                              style={{ width: '100%', height: '100%' }}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                    {!quest[idx]?.completed &&
                      <Grid item xs={12}>

                        <button
                          style={{ width: "150px", marginBottom: '20px', margin: '10px', float: 'right' }}
                          className="btn btn-primary text-white pr-2"
                          
                          type="submit"
                        >
                          Save & Continue
                        </button>
                        <button
                          style={{ width: "150px", marginBottom: '20px', margin: '10px', float: 'right' }}
                          className="btn btn-primary btn-light"
                          type="button"
                        >
                          Cancel
                        </button>


                      </Grid>}
                    {quest[idx]?.completed && quest[idx]?.response?.file && <Grid item xs={12}>
                      <a href={quest[idx]?.response?.file + "?" + sasToken} target="_blank">
                        <button
                          style={{ float: 'right' }}
                          disabled={quest[idx]?.response?.completed}
                          className="btn btn-sm btn-light text-dark"
                        >
                          <i className="fas fa-download" />&nbsp;Download Attachment
                        </button>
                      </a></Grid>}
                  </Grid>
                </form>
              </AccordionDetails>}
            </Accordion>
          )}
        </CardContent>
      </Card>
    </Box>

  );
};

const mapStateToProps = (state) => ({
  sites: state.site.sites,
  users: state.site.users,
  siteAssets: state.site.siteAssets,
  siteSelectedForGlobal: state.site.siteSelectedForGlobal,
  siteLayout: state.site.siteLayout,
});
export default connect(mapStateToProps, { getSiteCheckAssets, deleteUser, getSites, getSiteLayout })(
  AssessmentFireRisk
);

